import { VersionConfigModel } from "./models/config";

export const VersionConfig: VersionConfigModel = {
  VERSION: "2.3.1.80",
  VERSION_CODE: 230180
};